'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalPrintShop = function MdLocalPrintShop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 5v6.6h-20v-6.6h20z m1.6 15q0.7 0 1.3-0.5t0.5-1.1-0.5-1.3-1.3-0.5-1.1 0.5-0.5 1.3 0.5 1.1 1.1 0.5z m-5 11.6v-8.2h-13.2v8.2h13.2z m5-18.2q2.1 0 3.6 1.4t1.4 3.6v10h-6.6v6.6h-20v-6.6h-6.6v-10q0-2.1 1.4-3.6t3.6-1.4h23.2z' })
        )
    );
};

exports.default = MdLocalPrintShop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-print-shop.js
// module id = 1647
// module chunks = 168707334958949